'use strict';

/* global $ */

function Tabs(options) {

	let opt = $.extend(true, {}, options);

	function initBlock(el) {
		let $el = $(el);

		console.log('[ Tabs/Init ]');

		opt = $.extend({
			item: opt.selector+'__item',
			block: opt.selector+'__block',
		}, opt);

		$(opt.item).on('click', function(e) {
			console.log('[ Tabs/Click ]');
			e.preventDefault();
			$el.find(opt.item).removeClass('is-active');
			$(this).addClass('is-active');
			let id = $(this).attr('href');
			console.log(id, $el.find(opt.block));
			$el.find(opt.block).removeClass('is-open');
			$el.find(id).addClass('is-open');
		});
		$el.find(opt.item).removeClass('is-active');
		$el.find(opt.item).eq(0).addClass('is-active');
		$el.find(opt.block).removeClass('is-open');
		$el.find(opt.block).eq(0).addClass('is-open');
	}

	$(opt.selector).each(function() {
		initBlock(this);
	});
}

export {
	Tabs
};
